import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  NbComponentStatus,
  NbDialogRef,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";
import * as _ from "lodash";
import * as moment from "moment";
import { Subject } from "rxjs";
import { environment } from "../../../../environments/environment";
import { User } from "../../../@core/data/users";
import { UserService } from "../../../@core/services/user.service";
import { convertTimestamp } from "../../../@core/utils/convertTimestamps.service";

import { Person } from "../../../models/person.model";

import Shop from "../../../models/shop.model";
import { CustomerService } from "../../../services/customer.service";

import { Customer } from "../../../models/customer.model";
import WorkingTask from "../../../models/working-task.model";
import { WorkingTaskService } from "../../../services/working-task.service";
import { DialogWorkingTaskComponent } from "../../dialog-working-task/dialog-working-task.component";
import { DialogDeptCustomerComponent } from "../../dialog-dept-customer/dialog-dept-customer.component";

@Component({
  selector: "ngx-dialog-customer-task",
  templateUrl: "dialog-customer-task.component.html",
  styleUrls: ["dialog-customer-task.component.scss"],
})
export class DialogCustomerTaskComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() menu: string = "info"; //info / detail
  @Input() header: string;
  @Input() shopId?: string;
  @Input() shop?: Shop;
  @Input() uid?: string;
  @Input() user?: User;
  @Input() users?: Person[] = [];
  @Input() customer?: Customer;
  @Input() mode: string; //new/edit

  @ViewChild("title") title: ElementRef;

  loading = false;
  submitted = false;

  taskForm: FormGroup;
  edited = false;

  formatCurrency: string = environment.formatCurrency
    ? environment.formatCurrency
    : "#,###,###,###";

  errMessagesDetail: string = "";
  errMessages: string = "";
  workingTask: WorkingTask = new WorkingTask();

  workingTasks?: WorkingTask[] = [];
  display?: WorkingTask[] = [];

  strSearch = "";

  crmView: boolean = true;

  period: string = "thisMonth"; //thisMonth/today
  periodType: string = "day";
  periodDate: Date = moment().toDate();
  fromDate: Date = moment().startOf("month").startOf("day").toDate();
  toDate: Date = moment().endOf("month").endOf("day").toDate();
  dataSubscribe: any;

  page: number = 1;
  itemsPerPage: number = 10;
  objectType: string = "";
  customerId: string = "";
  customerName: string = "";
  assignBy: string = "";
  assignName: string = "";

  constructor(
    protected ref: NbDialogRef<DialogCustomerTaskComponent>,
    private userService: UserService,
    public customerService: CustomerService,
    private workingTaskService: WorkingTaskService,
    private dialogService: NbDialogService,
    private fb: FormBuilder,
    private toastrService: NbToastrService
  ) {}

  ngOnInit() {
    const titleValidators = [
      Validators.minLength(2),
      Validators.maxLength(250),
      Validators.required,
    ];

    this.taskForm = this.fb.group({
      title: ["", titleValidators],
    });

    this.workingTask.issueDate = new Date();

    console.log("DialogLoanComponent/ngOnInit/customer:", this.customer);
    this.getWorkingTasks();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  cancel() {
    this.ref.close(this.customer);
  }

  selectMenu(value) {
    this.menu = value;
    if (value === "receipt") {
      this.calculateDeptCustomer();
    }
  }

  selectTime(value) {
    if (value) {
      this.periodDate = value.periodDate;
      this.fromDate = value.fromDate;
      this.toDate = value.toDate;
      this.periodType = value.type;
      this.period = value.period;
      this.getWorkingTasks();
    }
  }

  calculateDeptCustomer() {
    this.dialogService
      .open(DialogDeptCustomerComponent, {
        context: {
          shopId: this.shopId,
          uid: this.uid,
          user: this.user,
          shop: this.shop,
          customer: this.customer,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value: Customer) => {
        if (value) {
          this.customer.saleQuantity = value.saleQuantity;
          this.customer.saleAmount = value.saleAmount;
          this.customer.paidAmount = value.paidAmount;
          this.customer.debitAmount = value.debitAmount;
          this.customer.profitAmount = value.profitAmount;
        }
        this.selectMenu("info");
      });
  }

  pageChange(page: number) {
    this.page = page;
  }

  onEdit(item: WorkingTask) {
    if (item) {
      for (let i = 0; i < this.workingTasks.length; i++) {
        if (this.workingTasks[i].id == item.id) {
          this.workingTasks[i] = item;
          break;
        }
      }
      this.onSearch();
    }
  }

  onEditCustomer(item: Customer) {
    if (item) {
      this.customer = item;
    }
  }

  onNew() {
    let task = new WorkingTask();
    task.shopId = this.shopId;

    this.dialogService
      .open(DialogWorkingTaskComponent, {
        context: {
          shopId: this.shopId,
          uid: this.uid,
          user: this.user,
          header: "Tạo việc mới",
          mode: "new",
          customer: this.customer,
          users: this.users,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.workingTasks = [value, ...this.workingTasks];
          this.display = [value, ...this.display];
        }
      });
  }

  viewTaskDetail(item: WorkingTask) {
    let lecNew = new WorkingTask();
    lecNew = _.clone(item);
    this.dialogService
      .open(DialogWorkingTaskComponent, {
        context: {
          shopId: this.shopId,
          uid: this.uid,
          user: this.user,
          header: lecNew.title,
          mode: "edit",
          task: lecNew,
          customer: this.customer,
          users: this.users,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          lecNew = item;
          this.onEdit(value);
        }
      });
  }

  create() {
    this.workingTask.shopId = this.shopId;
    this.workingTask.title = this.workingTask.title
      ? this.workingTask.title.trim()
      : "";

    this.workingTask.issueDate = moment().startOf("day").toDate();
    this.workingTask.issueDateYear = this.workingTask.issueDate.getFullYear();
    this.workingTask.issueDateMonth = this.workingTask.issueDate.getMonth() + 1;
    this.workingTask.issueDateDay = this.workingTask.issueDate.getDate();
    this.workingTask.issueDateWeekDay = this.workingTask.issueDate.getDay();
    this.workingTask.issueDateHours = this.workingTask.issueDate.getHours();
    this.workingTask.issueDateMinutes = this.workingTask.issueDate.getMinutes();
    this.workingTask.issueDateSeconds = this.workingTask.issueDate.getSeconds();
    this.workingTask.priority = 0;

    this.workingTask.customerId = this.customer.id;
    this.workingTask.customerName = this.customer ? this.customer.fullName : "";

    this.workingTask.assignBy = this.uid;
    this.workingTask.assignName = this.user.displayName;
    this.workingTask.assignee = this.user;

    if (this.workingTask.title.length > 0) {
      this.loading = true;
      this.submitted = true;

      this.workingTaskService
        .create(this.workingTask)
        .then((data) => {
          this.workingTask = new WorkingTask();
          this.title.nativeElement.focus();

          this.workingTasks = [data, ...this.workingTasks];
          this.display = [data, ...this.display];

          this.loading = false;
          this.submitted = false;

          this.showToast("success", "Cập nhật công việc", "thành công");
        })
        .catch((err) => {
          console.log("ViewWorkingTasksComponent/create/error:", err);
          this.loading = false;
          this.submitted = false;

          this.showToast("warning", "Cập nhật công việc", "thất bại");
        });
    }
  }

  //Control events
  onSearch(): void {
    this.loading = true;
    this.page = 1;
    const strFilter = this.strSearch ? this.strSearch.toLowerCase() : "";

    const workingTasks = _.clone(this.workingTasks);

    let display = [];
    _.forEach(workingTasks, (item) => {
      const title = item.title ? item.title.toLowerCase() : "";
      const description = item.description
        ? item.description.toLowerCase()
        : "";
      const customerName = item.customerName
        ? item.customerName.toLowerCase()
        : "";

      if (
        (this.assignBy === "" ||
          (this.assignBy !== "" && item.assignBy === this.assignBy)) &&
        ((title && title.includes(strFilter)) ||
          (customerName && customerName.includes(strFilter)) ||
          (description && description.includes(strFilter)))
      ) {
        display.push(item);
      }
    });
    this.display = [...display];
    this.loading = false;
  }

  //load data
  private async getWorkingTasks() {
    this.loading = true;
    const querySnapshot =
      await this.workingTaskService.getWorkingTasksByCustomer(
        this.shopId,
        this.customer.id,
        this.fromDate,
        this.toDate
      );
    this.workingTasks = [];

    querySnapshot.forEach((doc) => {
      let prod = new WorkingTask();
      prod = doc.data();
      prod.id = doc.id;

      prod.createdOn = convertTimestamp(prod.createdOn);
      prod.updatedOn = convertTimestamp(prod.updatedOn);
      prod.issueDate = convertTimestamp(prod.issueDate);
      prod.dueDate = convertTimestamp(prod.dueDate);

      this.workingTasks.push(prod);
    });

    this.loading = false;
    console.log("getWorkingTasks:", this.workingTasks);
    this.onSearch();
  }

  //---
  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
